import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import {
  Banner,
  BannerActions,
} from "../../domain/banner";
import { allBannersUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getAllBannersService = {
  async execute(token: string): Promise<Banner[]> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(allBannersUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "GET",
      null,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }

    return BannerActions().deserialize(response.content);
  },
};
